module.exports = __webpack_public_path__ + "media/06 can’t help but do sth.ff393f3c.mp3";